(ns kyber.components.base.icons
  (:require [kyber.styles.core :refer [styles->classes gs]]))

(def ^{:private true} icons
  {:align-left ["far" "fa-align-left"]
   :arrow-right ["fal" "fa-arrow-to-right"]
   :arrow-right-simple ["fal" "fa-arrow-right"]
   :bars ["fal" "fa-bars"]
   :bell ["fas" "fa-bell"]
   :bold ["far" "fa-bold"]
   :bold-light ["fal" "fa-bold"]
   :bookmark ["fal" "fa-bookmark"]
   :bookmark-solid ["fal" "fa-bookmark"]
   :books ["fal" "fa-books"]
   :camera ["fal" "fa-camera"]
   :calendar ["fas" "fa-calendar-alt"]
   :caret-left ["fal" "fa-caret-left"]
   :caret-right ["fal" "fa-caret-right"]
   :check ["fal" "fa-check"]
   :chart-up ["fas" "fa-chart-line"]
   :check-regular ["far" "fa-check"]
   :check-circle ["fas" "fa-check-circle"]
   :check-circle-empty ["far" "fa-check-circle"]
   :check-square ["fas" "fa-check-square"]
   :check-square-empty ["far" "fa-check-square"]
   :chevron-left ["fal" "fa-chevron-left"]
   :chevron-right ["fal" "fa-chevron-right"]
   :chevron-down ["fal" "fa-chevron-down"]
   :chevron-up ["fal" "fa-chevron-up"]
   :circle ["far" "fa-circle"]
   :circle-fill ["fas" "fa-circle"]
   :close ["fal" "fa-times"]
   :clipboard ["fas" "fa-clipboard-list-check"]
   :cloud-upload ["fas" "fa-cloud-upload"]
   :cogs ["fas" "fa-cogs"]
   :cog ["fas" "fa-cog"]
   :columns ["fal" "fa-columns"]
   :comment ["fas" "fa-comment"]
   :comment-exclamation ["far" "fa-comment-exclamation"]
   :compress ["far" "fa-compress"]
   :dashboard ["fal" "fa-chart-area"]
   :delete ["fal" "fa-trash"]
   :download ["fal" "fa-download"]
   :edit ["fal" "fa-pencil-alt"]
   :eye ["fas" "fa-eye"]
   :expand ["far" "fa-expand"]
   :external-link ["fal" "fa-external-link"]
   :exclamation ["fas" "fa-exclamation"]
   :exclamation-circle ["far" "fa-exclamation-circle"]
   :exclamation-circle-solid ["fas" "fa-exclamation-circle"]
   :exclamation-triangle ["fas" "fa-exclamation-triangle"]
   :facebook ["fab" "fa-facebook"]
   :falt-foward ["fal" "fa-falt-forward"]
   :file-alt ["fas" "fa-file-alt"]
   :file-audio ["fas" "fa-file-audio"]
   :file-image ["fas" "fa-file-image"]
   :file-pdf ["fas" "fa-file-pdf"]
   :file-video ["fas" "fa-file-video"]
   :friends ["far" "fa-user-friends"]
   :friends-solid ["fas" "fa-user-friends"]
   :grip-lines-vertical ["far" "fa-grip-lines-vertical"]
   :grip-vertical ["fas" "fa-grip-vertical"]
   :google ["fab" "fa-google"]
   :graduation-cap ["fal" "fa-graduation-cap"]
   :heading ["far" "fa-heading"]
   :heading-light ["fal" "fa-heading"]
   :heading-1 ["far" "fa-h1"]
   :heading-1-light ["fal" "fa-h1"]
   :heading-2 ["far" "fa-h2"]
   :heading-2-light ["fal" "fa-h2"]
   :heading-3 ["far" "fa-h3"]
   :heading-3-light ["fal" "fa-h3"]
   :help ["fal" "fa-question"]
   :highlighter ["fas" "fa-highlighter"]
   :inbox-in ["fas" "fa-inbox-in"]
   :images ["fal" "fa-images"]
   :info ["fal" "fa-info"]
   :italic ["far" "fa-italic"]
   :italic-light ["fal" "fa-italic"]
   :level-up-alt ["far" "fa-level-up-alt" "fa-rotate-90"]
   :list-square ["far" "fa-list"]
   :list ["far" "fa-list-ul"]
   :list-light ["fal" "fa-list-ul"]
   :list-ordered ["far" "fa-list-ol"]
   :list-ordered-light ["fal" "fa-list-ol"]
   :loading ["fal" "fa-spinner"]
   :mindset-low ["fas" "fa-tachometer-alt-slow"]
   :mindset-medium ["fas" "fa-tachometer-alt"]
   :mindset-high ["fas" "fa-tachometer-alt-fastest"]
   :magic ["fal" "fas fa-magic"]
   :minus ["fal" "fa-minus"]
   :minus-circle ["far" "fa-minus-circle"]
   :note ["fas" "fa-sticky-note"]
   :volume-off ["fal" "fa-volume-off"]
   :volume-up ["fal" "fa-volume-up"]
   :paragraph ["far" "fa-paragraph"]
   :paragraph-light ["fal" "fa-paragraph"]
   :pause ["fas" "fa-pause"]
   :pause-circle ["fas" "fa-pause-circle"]
   :pin ["far" "fa-thumbtack"]
   :play ["fas" "fa-play"]
   :play-circle ["fas" "fa-play-circle"]
   :play-circle-light ["fal" "fa-play-circle"]
   :plus ["fal" "fa-plus"]
   :plus-circle ["far" "fa-plus-circle"]
   :question-circle ["fas" "fa-question-circle"]
   :question-mark ["far" "fa-question"]
   :reload ["fal" "fa-sync-alt"]
   :rows ["fal" "fa-columns" "fa-rotate-270"]
   :search ["fal" "fa-search"]
   :settings ["fal" "fa-sliders-h"]
   :sort-up ["far" "fa-sort-up"]
   :sort-down ["far" "fa-sort-down"]
   :square ["fal" "fa-square"]
   :star-filled ["fas" "fa-star"]
   :star ["far" "fa-star"]
   :sticky-note ["fas" "fa-sticky-note"]
   :stream ["far" "fa-stream"]
   :subscript ["far" "fa-subscript"]
   :subscript-light ["fal" "fa-subscript"]
   :superscript ["far" "fa-superscript"]
   :superscript-light ["fal" "fa-superscript"]
   :table ["far" "fa-table"]
   :times ["fal" "fa-times"]
   :times-circle ["fas" "fa-times-circle"]
   :underline ["far" "fa-underline"]
   :underline-light ["fal" "fa-underline"]
   :undo ["fas" "fa-undo-alt"]
   :user-circle ["fas" "fa-user-circle"]
   :vector-square ["far" "fa-vector-square"]
   :warning ["fal" "fa-exclamation-circle"]
   :warning-solid ["fas" "fa-exclamation-circle"]
   :warning-square ["fas fa-exclamation-square"]
   :warning-triangle ["fal" "fa-exclamation-triangle"]})

(def ^{:private true} fa-class-map
  {:small "fa-sm"
   :default "fa-lg"
   :large "fa-2x"
   :x-large "fa-3x"
   :massive "fa-4x"})

(def base-icon-styles
  {:color (gs [:colors :gray-scale-600])
   :line-height (gs [:font-height :icon])})

(def icon-styles
  {:small (merge base-icon-styles
                 {:font-size (gs [:font-size :icon-sm])

                  (gs [:queries :tablet])
                  {:font-size (gs [:font-size :icon-sm/tablet])}

                  (gs [:queries :mobile-landscape])
                  {:font-size (gs [:font-size :icon-sm/mobile])}})
   :default (merge base-icon-styles
                   {:font-size (gs [:font-size :icon])

                    (gs [:queries :tablet])
                    {:font-size (gs [:font-size :icon/tablet])}

                    (gs [:queries :mobile-landscape])
                    {:font-size (gs [:font-size :icon/mobile])}})
   :large (merge base-icon-styles
                 {:font-size (gs [:font-size :icon-lg])

                  (gs [:queries :tablet])
                  {:font-size (gs [:font-size :icon-lg/tablet])}

                  (gs [:queries :mobile-landscape])
                  {:font-size (gs [:font-size :icon-lg/mobile])}})
   :x-large (merge base-icon-styles
                   {:font-size (gs [:font-size :icon-xl])

                    (gs [:queries :tablet])
                    {:font-size (gs [:font-size :icon-xl/tablet])}

                    (gs [:queries :mobile-landscape])
                    {:font-size (gs [:font-size :icon-xl/mobile])}})
   :massive (merge base-icon-styles
                   {:font-size (gs [:font-size :icon-massive])

                    (gs [:queries :tablet])
                    {:font-size (gs [:font-size :icon-massive/tablet])}

                    (gs [:queries :mobile-landscape])
                    {:font-size (gs [:font-size :icon-massive/mobile])}})})

(def icon-classes
  (styles->classes icon-styles))

(defn- render-icon
  [size [fa-type-class fa-class fa-rotate]
   {:keys [class] :as props}]
  [:i (assoc (merge {:aria-hidden "true"} props) :class
             (cond-> [(size fa-class-map)
                      (size icon-classes)
                      fa-type-class
                      fa-class]

               (string? class) (conj class)
               (coll? class) (concat class)
               fa-rotate (conj fa-rotate)))])

(defn icon-sm
  {:doc "Small icons"}
  ([icon-name] [icon-sm {} icon-name])
  ([props icon-name]
   [render-icon :small (icon-name icons) props]))

(defn icon
  {:doc "Default icons"}
  ([icon-name] [icon {} icon-name])
  ([props icon-name]
   [render-icon :default (icon-name icons) props]))

(defn icon-lg
  {:doc "Large icons"}
  ([icon-name] [icon-lg {} icon-name])
  ([props icon-name]
   [render-icon :large (icon-name icons) props]))

(defn icon-xl
  {:doc "Extra Large icons"}
  ([icon-name] [icon-xl {} icon-name])
  ([props icon-name]
   [render-icon :x-large (icon-name icons) props]))

(defn icon-massive
  {:doc "Massive icons"}
  ([icon-name] [icon-massive {} icon-name])
  ([props icon-name]
   [render-icon :massive (icon-name icons) props]))
